<template>
    <div id="steamReport">
        <headerBg class="headerBg" :headerBg="headerBg"></headerBg>
        <div class="name" :style="nameBg">
            <img class="icon" :style="iconSty" :src="logoIcon" alt="" />
            <span>{{ type }} DATA REPORT</span>
            <img class="arrow" src="../assets/image/steam/sanjiao.png" alt="" />
        </div>
        <div class="title">
            2024数据报告
        </div>
        <div class="infoBox">
            <div>
                <div class="information">
                    <div class="left">
                        <img v-if="$route.query.type != 'epic'" class="headImg" :src="data.portrait" alt="" />
                        <img v-if="$route.query.type == 'epic'" class="headImg" :src="data.avatar" alt="" />
                    </div>
                    <div class="right">
                        <span class="id">ID:</span>
                        <div class="userId" v-if="$route.query.type == 'steam'">{{ data.steamUserName }}</div>
                        <div class="userId" v-if="$route.query.type == 'psn'">{{ data.psnUserName }}</div>
                        <div class="userId" v-if="$route.query.type == 'xbox'">{{ data.xblUserName }}</div>
                        <div class="userId" v-if="$route.query.type == 'epic'">{{ data.epicUserName }}</div>
                        <div class="lv-Region" v-if="$route.query.type == 'steam' || $route.query.type == 'psn'">
                            <span class="lv">
                                Lv<span class="lvNumber" :style="colorSty">{{ data.accountGrade }}</span>
                            </span>
                            <span class="line"></span>
                            <span class="region">
                              
                                <div class="icon" v-if="data.accountArea=='hk' || data.accountArea=='tw'">{{countryFlagInfes["CN"]}}</div>
                                <div class="icon" v-if="data.accountArea=='HK' || data.accountArea=='TW'">{{countryFlagInfes["CN"]}}</div>                              
                               
                                <div class="icon" v-if="data.accountArea!='HK' && data.accountArea!='TW' && data.accountArea=='hk' && data.accountArea=='tw'">
                                    {{countryFlagInfes["'"+data.accountArea.toUpperCase()+"'"]}}</div>
                            

                                <span class="regionName">{{ data.accountArea }}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="gameInfo">
                    <div class="infoBox" v-if="$route.query.type != 'xbox'">
                        <div v-if="$route.query.type != 'epic'">
                            <div class="label">游戏总价值(元)</div>
                            <div class="value" v-if="$route.query.type != 'epic'">
                                <i :style="lineBgSty"></i>{{ data.numberPrice }}
                            </div>
                        </div>
                        <div v-if="$route.query.type == 'epic'">
                            <div class="label">账号总价值(元)</div>
                            <div class="value"><i :style="lineBgSty"></i>{{ data.accountValue }}</div>
                        </div>
                        <!-- <div class="line" ></div> -->
                    </div>
                    <div class="line" v-if="$route.query.type == 'steam' || $route.query.type == 'psn'"></div>
                    <div class="infoBox" v-if="$route.query.type == 'steam' || $route.query.type == 'psn'">
                        <div>
                            <div class="label">游戏总时长(时)</div>
                            <div class="value"><i :style="lineBgSty"></i>{{ data.allPlayTime }}</div>
                        </div>
                        <!-- <div class="line" ></div> -->
                    </div>
                    <div class="infoBox" v-if="$route.query.type == 'xbox'" style="width:2.7rem">
                        <div>
                            <div class="label">账号成就点数</div>
                            <div class="value">
                                <i :style="lineBgSty"></i>{{ data.achievementPoints | numberToCurrency(0) }}
                            </div>
                        </div>
                        <!-- <div class="line" ></div> -->
                    </div>
                    <div class="line"></div>
                    <div class="infoBox">
                        <div>
                            <div class="label">游戏总数量(个)</div>
                            <div class="value">
                                <i :style="lineBgSty"></i>{{ data.gameNumber | numberToCurrency(0) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <img src="../assets/image/steam/sanjiao1.png" alt="" />
            </div>
        </div>

        <div class="yearData" :style="yearDataSty">
            <div class="border">
                <div class="dataTitle" :style="dataTitleBgSty">年度数据</div>
                <div class="data" v-if="$route.query.type != 'xbox'">
                    <div class="bottomTxt">
                        PRICE
                        <div class="topTxt">游戏价值 <span :style="colorSty">IN 2024</span></div>
                    </div>

                    <div class="line"></div>
                    <div class="num" v-if="$route.query.type != 'epic'">
                        {{ data.yearGamePrice }}<span :style="colorSty">元</span>
                    </div>
                    <div class="num" v-if="$route.query.type == 'epic'">
                        {{ data.freeGameValue | numberToCurrency(0) }}<span :style="colorSty">元</span>
                    </div>
                </div>
                <div class="data" v-if="$route.query.type != 'xbox'">
                    <div class="bottomTxt">
                        TIMES
                        <div class="topTxt">游玩时长<span :style="colorSty">IN 2024</span></div>
                    </div>

                    <div class="line"></div>
                    <div class="num" v-if="$route.query.type != 'epic'">
                        {{ data.yearPlayTime }}<span :style="colorSty">时</span>
                    </div>
                    <div class="num" v-if="$route.query.type == 'epic'">
                        {{ data.freeGamePlayTime | numberToCurrency(0) }}<span :style="colorSty">时</span>
                    </div>
                </div>
                <div class="data xboxData" v-if="$route.query.type == 'xbox'">
                    <div class="bottomTxt">
                        success
                        <div class="topTxt">成就点数<span :style="colorSty">IN 2024</span></div>
                    </div>

                    <div class="line"></div>
                    <div class="num">
                        {{ data.yearAchievementPoints | numberToCurrency(0) }}<span :style="colorSty">点</span>
                    </div>
                </div>
                <div class="data lastData">
                    <div class="bottomTxt">
                        GAMES
                        <div class="topTxt">游戏数量 <span :style="colorSty">IN 2024</span></div>
                    </div>

                    <div class="line"></div>
                    <div class="num" v-if="$route.query.type != 'epic'">
                        {{ data.yearGameNumber | numberToCurrency(0) }}<span :style="colorSty">个</span>
                    </div>
                    <div class="num" v-if="$route.query.type == 'epic'">
                        {{ data.freeGameNumber | numberToCurrency(0) }}<span :style="colorSty">个</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <img :src="xiegangSrc" alt="" />
            <span v-if="$route.query.type == 'steam' || $route.query.type == 'xbox'">年报数据为今年发售且在库中的游戏</span>
            <span v-if="$route.query.type == 'psn'">数据来源于第一次游玩时间为今年的游戏</span>
            <span v-if="$route.query.type == 'epic'">数据来源于EPIC今年白嫖过的游戏</span>
        </div>

        <footerPage class="footerPage"></footerPage>
        <footerBg class="footerBg" :footerBg="footerBg"></footerBg>
    </div>
</template>

<script>
import footerPage from "./footer.vue";
import footerBg from "./footerBg.vue";
import headerBg from "./headerBg.vue";
import { numberToCurrency } from "../assets/js/numberToCurrency";
export default {
    name: "steamReport",
    filters: {
        numberToCurrency
    },
    props: {
        data: {
            type: [Object]
        }
    },
    data() {
        return {
            logoIcon: "",
            type: "",

            footerBg: {},
            headerBg: {},
            xiegangSrc: require("../assets/image/" + this.$route.query.type + "/" + "xiegang.png"),
            yearDataSty: {
                background:
                    "url(" +
                    require("../assets/image/" + this.$route.query.type + "/" + this.$route.query.type + "Border.png") +
                    ")",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100%"
            },
            nameBg: {},
            colorSty: {},
            lineBgSty: {},
            dataTitleBgSty: {},
            iconSty: {},

            countryFlagInfes: {
                "US":"🇺🇸",
                "CN":"🇨🇳",
                "JP":"🇯🇵",
                "DE":"🇩🇪",
                "FR":"🇫🇷",
                "GB":"🇬🇧",
                "IN":"🇮🇳",
                "BR":"🇧🇷",
                "IT":"🇮🇹",
                "CA":"🇨🇦",
                "KP":"🇰🇷",
                "RU":"🇷🇺",
                "AU":"🇦🇺",
                "ES":"🇪🇸",
                "MX":"🇲🇽",
                "ID":"🇮🇩",
                "TR":"🇹🇷",
                "NL":"🇳🇱",
                "CH":"🇨🇭",
                "SA":"🇸🇦",
                "AR":"🇦🇷",
                "SE":"🇸🇪",
                //"TW":"🇨🇳",
                "PL":"🇵🇱",
                "BE":"🇧🇪",
                "TH":"🇹🇭",
                "NG":"🇳🇬",
                "AT":"🇦🇹",
                "NO":"🇳🇴",
                "AE":"🇦🇪",
                "IR":"🇮🇷",
                "IL":"🇮🇱",
                "ZA":"🇿🇦",
                "PH":"🇵🇭",
                "IE":"🇮🇪",
                "DK":"🇩🇰",
                //"HK":"🇭🇰",
                "MY":"🇲🇾",
                "CO":"🇨🇴",
                "SG":"🇸🇬",
                "BD":"🇧🇩",
                "FI":"🇫🇮",
                "CL":"🇨🇱",
                "CZ":"🇨🇿",
                "VN":"🇻🇳",
                "PT":"🇵🇹",
                "PE":"🇵🇪",
                "GR":"🇬🇷",
                "NZ":"🇳🇿",
                "VE":"🇻🇪"
            }
        };
    },
    mounted() {
        

        if (this.$route.query.type == "steam") {
            this.type = "STEAM";
            this.logoIcon = require("../assets/image/steam/steam_small.png");
            this.headerBg = {
                background: "url(" + require("../assets/image/steam/steam.png") + ")",
                width: "11.3rem",
                height: "11.25rem",
                backgroundSize: "120%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right"
            };
            this.footerBg = {
                height: "12rem",
                top: "30rem",
                background: "url(" + require("../assets/image/steam/footer2.png") + ")",
                backgroundSize: "100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right"
            };
            this.nameBg = {
                background: "#1A515C"
            };
            this.colorSty = {
                color: "#5EE6FF"
            };
            this.lineBgSty = {
                background: "#5EE6FF"
            };
            this.dataTitleBgSty = {
                background: " #1A515C"
            };
        } else if (this.$route.query.type == "psn") {
            this.type = "PSN";
            this.logoIcon = require("../assets/image/psn/psn_small.png");
            this.headerBg = {
                background: "url(" + require("../assets/image/psn/psn.png") + ")",
                width: "11.85rem",
                height: "11.4rem",
                backgroundSize: "100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right"
            };
            this.footerBg = {
                height: "12rem",
                top: "30rem",
                background: "url(" + require("../assets/image/psn/footer2.png") + ")",
                backgroundSize: "100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right"
            };
            this.nameBg = {
                background: "#192A52",
                width: "12.9rem"
            };
            this.colorSty = {
                color: "#5EA6FF"
            };
            this.lineBgSty = {
                background: "#5EA6FF"
            };
            this.dataTitleBgSty = {
                background: " #192A52"
            };
        } else if (this.$route.query.type == "xbox") {
            this.type = "XBOX";
            this.logoIcon = require("../assets/image/xbox/xbox_small.png");
            this.headerBg = {
                background: "url(" + require("../assets/image/xbox/xbox.png") + ")",
                width: "10.35rem",
                height: "11.55rem",
                backgroundSize: "100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right"
            };
            this.footerBg = {
                height: "12rem",
                top: "30rem",
                background: "url(" + require("../assets/image/xbox/footer2.png") + ")",
                backgroundSize: "100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right"
            };
            this.nameBg = {
                background: "#195229"
                // width:'12.9rem'
            };
            this.colorSty = {
                color: "#5EFF97"
            };
            this.lineBgSty = {
                background: "#5EFF97"
            };
            this.dataTitleBgSty = {
                background: " #195229"
            };
        } else if (this.$route.query.type == "epic") {
            this.type = "EPIC";
            this.logoIcon = require("../assets/image/epic/epic_small.png");
            this.headerBg = {
                background: "url(" + require("../assets/image/epic/epic.png") + ")",
                width: "10.35rem",
                height: "12rem",
                backgroundSize: "100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right"
            };
            this.footerBg = {
                height: "12rem",
                top: "30rem",
                background: "url(" + require("../assets/image/epic/footer2.png") + ")",
                backgroundSize: "100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right"
            };
            this.nameBg = {
                background: "#484848",
                width: "13.15rem"
            };
            this.lineBgSty = {
                background: "#FF5E5E"
            };
            this.colorSty = {
                color: "#FF5E5E"
            };
            this.dataTitleBgSty = {
                background: " #484848"
            };
            this.iconSty.width = "0.85rem";
            this.iconSty.height = "0.95rem";
        }
    },

    methods: {
        getNumber(val) {
            if (val) {
                return val.toFixed(0);
            }
        }
    },
    components: {
        footerPage,
        footerBg,
        headerBg
    }
};
</script>

<style>
#steamReport {
    padding: 4rem 1.95rem 0;
    margin: 0 auto;
}
.headerBg {
    position: fixed;
    top: 0;
    left: 0;
}
#steamReport .name {
    /* padding: 0.45rem 0.85rem 0.5rem 0.7rem; */
    width: 12.9rem;
    height: 1.75rem;
    /* background: #1A515C; */
    /* margin-top: 4.05rem; */
    margin-bottom: 0.5rem;

    display: flex;
    align-items: center;
}
#steamReport .name .icon {
    width: 0.9rem;
    height: 0.9rem;
    margin-right: 0.35rem;
    margin-left: 0.7rem;
}
#steamReport .name .arrow {
    width: 0.3rem;
    height: 0.55rem;
    margin-left: 0.55rem;
}
#steamReport .name span {
    font-size: 0.9rem;
    font-family: AlibabaPuHuiTiMedium;
    font-weight: 400;
    color: #fff;
    line-height: 0.8rem;
    /* margin-bottom: 0.1rem; */
}
#steamReport .title {
    font-size: 2.1rem;
    font-family: AlibabaPuHuiTiBold;
    font-weight: 400;
    color: #ffffff;
    margin-bottom: 0.9rem;
    line-height: 2.1rem;
}
#steamReport .infoBox {
    position: relative;
}
#steamReport .infoBox > div > img {
    width: 2.1rem;
    position: absolute;
    top: 0;
    right: 0;
}
#steamReport .information {
    display: flex;
    align-items: center;
}
#steamReport .information .left {
    width: 4.15rem;
    height: 4.15rem;
    background: #ccc;
    margin-right: 0.65rem;
}
#steamReport .information .left .headImg {
    width: 4.15rem;
    height: 4.15rem;
}
#steamReport .information .right {
    /* padding: 0.9rem 0; */
}
#steamReport .information .right .id {
    font-size: 0.6rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.6);
}
#steamReport .information .right .userId {
    width: 7.35rem;
    font-size: 0.75rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 1rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
#steamReport .information .right .lv-Region {
    display: flex;
    align-items: center;
}
#steamReport .information .right .lv-Region .line {
    width: 0.05rem;
    height: 0.75rem;
    background: #ffffff;
    opacity: 0.5;
    margin: 0 0.55rem;
    display: inline-block;
}
#steamReport .information .right .lv-Region {
    font-size: 0.6rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
}
#steamReport .information .right .lv-Region .lvNumber {
    font-weight: bold;
    margin-left: 0.1rem;
}
#steamReport .information .right .lv-Region .region {
    display: flex;
    align-items: center;
}
#steamReport .information .right .lv-Region .region .icon {
    width: 1.05rem;
    height: 0.7rem;
    margin-right: 0.2rem;
}
#steamReport .gameInfo {
    display: flex;
    align-items: center;
    margin-top: 0.7rem;
}
#steamReport .gameInfo .infoBox {
    display: flex;
    align-items: center;
    width: 3rem;
}
#steamReport .gameInfo .infoBox div {
    width: 100%;
}
#steamReport .gameInfo .infoBox .label {
    font-size: 0.45rem;
    color: rgba(255, 255, 255, 0.6);
    font-family: Source Han Sans CN;
    margin-bottom: 0.45rem;
    transform: scale(0.75);
    transform-origin: left;
    width: 4rem;
}
#steamReport .gameInfo .infoBox .value {
    font-size: 0.6rem;
    font-family: D-DINExp;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.6);
}
#steamReport .gameInfo .infoBox .value i {
    width: 0.05rem;
    height: 0.45rem;

    margin-right: 0.3rem;
    display: inline-block;
}
#steamReport .gameInfo .infoBox .value .pri {
    font-size: 0.55rem;
    font-family: D-DIN;
}
#steamReport .gameInfo .infoBox .value .time {
    font-size: 0.55rem;
    font-family: D-DIN;
    margin-left: 0.15rem;
}
#steamReport .gameInfo .infoBox .value .num {
    font-size: 0.4rem;
    font-family: Source Han Sans CN;
    margin-left: 0.4rem;
}
#steamReport .gameInfo .line {
    width: 0.05rem;
    height: 0.75rem;
    background: rgba(255, 255, 255, 0.5);
    margin: 0 0.85rem;
}
.yearData {
    position: relative;
    width: 13.15rem;
    height: 15.55rem;
    margin-top: 1.75rem;
    /* background:linear-gradient(-45deg,transparent 1.75rem,rgba(94,230,255,0.5) 0) bottom right; */
}
.yearData .border {
    width: 13.15rem;
    height: 15.55rem;
    /* background:linear-gradient(-45deg,transparent 1.75rem,#0B1E23 0) bottom right; */
    padding: 1.45rem 0 1.35rem 1rem;
    /* box-sizing: border-box; */
}

#steamReport .yearData .dataTitle {
    width: 5.2rem;
    height: 1.4rem;

    position: absolute;
    top: -0.6rem;
    right: -0.85rem;
    font-size: 0.85rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    line-height: 1.4rem;
}
#steamReport .yearData .data {
    margin-bottom: 1.8rem;
    height: 3rem;
}
#steamReport .yearData .xboxData {
    margin: 1.6rem 0 3.2rem;
}

#steamReport .yearData .data .bottomTxt {
    position: relative;
    font-size: 1.05rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.05);
    line-height: 1.05rem;
}
#steamReport .yearData .data .bottomTxt .topTxt {
    position: absolute;
    top: 0.45rem;
    left: 0.45rem;
    font-size: 0.85rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
}
#steamReport .yearData .data .bottomTxt .topTxt span {
    margin-left: 0.3rem;
    font-size: 0.45rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    display: inline-block;
    transform: scale(0.75);
    transform-origin: left;
}
#steamReport .yearData .data .line {
    margin-top: 0.45rem;
    width: 3.7rem;
    height: 0.05rem;
    background: #ffffff;
    opacity: 0.2;
    margin-left: 2.7rem;
}
#steamReport .yearData .data .num {
    margin: 0.4rem 0 0 4.05rem;
    font-size: 1.05rem;
    font-family: Impact;
    color: #ffffff;
}
#steamReport .yearData .data .num span {
    font-size: 0.45rem;
    font-family: Source Han Sans CN;

    margin-left: 0.4rem;
}
#steamReport .bottom {
    font-size: 0.5rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.4);
    margin-top: 0.35rem;
    margin-bottom: 5.35rem;
    transform: scale(0.833);
    transform-origin: left;
}

#steamReport .bottom img {
    width: 0.95rem;
    height: 0.45rem;
}
</style>
